<template>
  <div id="app" class="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body,.app{
 margin: 0 ;
 padding: 0;
}
</style>
